import { AuthService } from "./../services/auth.service";
import { Component } from "@angular/core";
import * as $ from "jquery";

@Component({
  selector: "pm-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.sass"]
})

export class FooterComponent {

  constructor(private _authService: AuthService) {}

  ngAfterViewInit() {

    
  }

}